module.exports = function () {
  return "\n        <div class=\"game-help-overlay\">\n          <div class=\"game-help-overlay-title\"></div>\n          <div class=\"game-help-overlay-text\"></div>\n          <div class=\"game-help-overlay-optout\"><input type=\"checkbox\" class=\"saito-checkbox\" name=\"dontshowme\" value=\"true\"/> don't show again </div>\n        </div>\n  ";
};

/* 
    Clean up from css files later on...
    
    .welcome, .welcome-overlay, .welcome-title, .welcome-text, .welcome-optout
    his-hud, his-welcome, paths-welcome, settlers-help, twilight-welcome
*/